import React from 'react';
import {oneOf, string} from 'prop-types';
import classnames from 'classnames';

import './Message.css';

export const Message = ({className, type, children}) => (
  <div className={classnames('Message', className)}>
    <span
      className={classnames({
        'Message-error': type === 'error',
        'Message-success': type === 'success'
      })}
    >{children}</span>
  </div>
);

Message.propTypes = {
  className: string,
  type: oneOf(['error', 'success', 'info']),
  children: string
};

Message.defaultProps = {
  className: '',
  children: ''
};

export const ErrorMessage = ({children, ...props}) => (
  <Message
    {...props}
    type="error"
  >
    {children}
  </Message>
);

ErrorMessage.propTypes = {
  children: string
};

ErrorMessage.defaultProps = {
  children: ''
};
